module.exports = __webpack_public_path__ + "img/BT-logo-black.d92cfff4.svg";